import React, { useEffect, useState, useRef } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as styles from "./HeaderImageSlider.module.scss";

const SLIDE_DURATION = 5000;

const HeaderImageSlider = ({ data }) => {
    const { slider } = data;
    const [currentIndex, setCurrentIndex] = useState(0);
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        setProgress(0);
        const startTime = Date.now();

        intervalRef.current = setInterval(() => {
            const elapsed = Date.now() - startTime;
            const percent = Math.min((elapsed / SLIDE_DURATION) * 100, 100);
            setProgress(percent);

            if (percent >= 100) {
                clearInterval(intervalRef.current!);
                setCurrentIndex((prev) => (prev + 1) % slider.length);
            }
        }, 50);

        return () => clearInterval(intervalRef.current!);
    }, [currentIndex, slider.length]);

    const currentSlide = slider[currentIndex];

    return (
        <div className={styles.sliderContainer}>
            <div className={styles.imageWrapper}  style={{ backgroundColor: currentSlide.backgroundColor }}>
                <GatsbyImage
                    image={getImage(currentSlide.image1.gatsbyImageData)}
                    alt={currentSlide.image1.title}
                    className={styles.image}
                />
                <GatsbyImage
                    image={getImage(currentSlide.image3.gatsbyImageData)}
                    alt={currentSlide.image3.title}
                    className={styles.image3}
                />
                <GatsbyImage
                    image={getImage(currentSlide.image4.gatsbyImageData)}
                    alt={currentSlide.image4.title}
                    className={styles.image4}
                />
            </div>
            <div className={styles.imageWrapperTwo} style={{ backgroundColor: currentSlide.backgroundColor }}>
                <GatsbyImage
                    image={getImage(currentSlide.image2.gatsbyImageData)}
                    alt={currentSlide.image2.title}
                    className={styles.image2}
                />
            </div>
            <div className={styles.textWrapper}>
                <div className={styles.content}>{currentSlide.content}</div>
            </div>
            <div className={styles.progressBar}>
                <div
                    className={styles.progressFill}
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
};

export default HeaderImageSlider;
